/**
 * PostHog kill-switch for the whole challenges/habits module (TRE-1367) — the same flag
 * that gates the client apps (mobile GoalsSection, client-web widget and /challenges pages).
 */
export const CHALLENGES_FEATURE_FLAG = "challenges";
